import React from 'react'

const Safe = () => {
  return (
    <div className='App'>
      <h1>Secret page</h1>
      <p>This is where we store the secrets. You have access to this page.</p>
    </div>
  )
}

export default Safe